import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import { CloseButton } from 'layouts/WideLayout/subcomponents'
import Header from 'components/Header'
import { Grid } from 'gu-ui-kit'
import clsx from 'clsx'
import Footer from 'components/Footer'
import findMatchedRoutes, { getLastMatchedRoute } from 'utils/findMatchedRoutes'
import LayoutSuspense from 'layouts/LayoutSuspense'
import { WideLayoutProvider, useWideLayoutContext } from 'layouts/WideLayout/context'

const WideLayoutContent = ({
  children = null,
  className = '',
  showSidebarToggle = true,
  hasCloseButton = true,
  header = null,
  footer = null,
}) => {
  const { invokeClose } = useWideLayoutContext()
  const matchedRoutes = findMatchedRoutes()

  return (
    <Grid
      className={clsx(styles['layout'], className)}
      component={'section'}
      direction={'column'}
      wrap={false}
    >
      <Grid
        direction={'row'}
        fluid
        wrap={false}
        className={styles['layout__header-container']}
        gap={8}
      >
        <Grid className={styles['layout__header']}>
          {header ?? <Header showSidebarToggle={showSidebarToggle} />}
        </Grid>

        {hasCloseButton && <CloseButton onClose={invokeClose} />}
      </Grid>

      <Grid
        className={styles['layout__content']}
        wrap={false}
        direction={'column'}
      >
        <Grid
          className={clsx({
            'layout-tile': !getLastMatchedRoute(matchedRoutes)?.restyled,
          })}
          alignSelf={'start'}
          wrap={false}
          direction={'column'}
        >
          <LayoutSuspense>{children}</LayoutSuspense>
        </Grid>
      </Grid>
      {footer ?? <Footer wide />}
    </Grid>
  )
}

WideLayoutContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  className: PropTypes.string,
  showSidebarToggle: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  header: PropTypes.node,
  footer: PropTypes.node,
}

const WideLayout = ({
  children = null,
  onClose,
  className = '',
  showSidebarToggle = false,
  hasCloseButton = true,
  header = null,
  footer = null,
}) => (
  <WideLayoutProvider defaultOnClose={onClose}>
    <WideLayoutContent
      className={className}
      showSidebarToggle={showSidebarToggle}
      hasCloseButton={hasCloseButton}
      header={header}
      footer={footer}
    >
      {children}
    </WideLayoutContent>
  </WideLayoutProvider>
)

WideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
  showSidebarToggle: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  header: PropTypes.node,
  footer: PropTypes.node,
}

export default WideLayout
